// extracted by mini-css-extract-plugin
module.exports = {"color":"styles_color__QANrp"};